import React from "react";

import Section from "../../../HOC/Section";
import bgImage from "../../../assets/img/facts_bg.jpg";

const Facts = () => {
  return (
    <Section id="facts">
      <div
        className="facts-container"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="container pt-5 pb-4 pl-5 pr-5">
          <div className="row">
            <div className="col-sm-6 col-md-4 text-center mb-4">
              <div className="mb-2 facts-icon">
                <i className="fas fa-users" />
              </div>
              <h4 className="facts-counter text-light">品牌齐全</h4>
              <h5 className="facts-title text-light">经验丰富</h5>
            </div>
            <div className="col-sm-6 col-md-4 text-center mb-4">
              <div className="mb-2 facts-icon">
                <i className="fas fa-grin-beam" />
              </div>
              <h4 className="facts-counter text-light">库存保障</h4>
              <h5 className="facts-title text-light"> 供货及时</h5>
            </div>
            <div className="col-sm-6 col-md-4 text-center mb-4">
              <div className="mb-2 facts-icon">
                <i className="fas fa-project-diagram" />
              </div>
              <h4 className="facts-counter text-light">服务保障</h4>
              <h5 className="facts-title text-light">全方位</h5>
            </div>
            {/* <div className="col-sm-6 col-md-3 text-center mb-4">
              <div className="mb-2 facts-icon">
                <i className="fas fa-trophy" />
              </div>
              <h4 className="facts-counter text-light">56</h4>
              <h5 className="facts-title text-light">Awards</h5>
            </div> */}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Facts;
